import { createStore } from '@stencil/store'
import { i18n } from '@rdss/core'
import { WishlistItems } from '@rdss/client';

export const store = createStore({
    cartItemsCount: 0,
    cartIsLoading: false,
    translations: {},
    wishlist: [] as WishlistItems,
})

/**
 * Translates a given key using the translation service and the application's current state.
 *
 * @param {string} key - The translation key to be translated.
 * @param {string} defaultValue - The default value to return if the translation is not found.
 * @param {Array} replaceValues - The default value to return if the translation is not found.
 * @returns {string} - The translated string or the default value if not found.
 *
 * @see translationService - The translation service function responsible for performing the translation.
 * @see store.state.translations - The translations stored in the application state.
 */
export const trans = (
    key: string,
    defaultValue?: string,
    replaceValues?: Array<string>
): string => {
    return i18n(key, defaultValue, replaceValues, store.state.translations)
}
